import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ChatWidgetStoreState } from './typings';

const initialState: ChatWidgetStoreState = {
    isVisible: false,
    unreadCount: 0,
};

const slice = createSlice({
    name: 'CHAT_WIDGET',
    initialState: initialState,
    reducers: {
        toggleWidget: (state, action: PayloadAction<boolean>) => {
            state.isVisible = action.payload;
        },
        setUnreadCount: (state, action: PayloadAction<number>) => {
            state.unreadCount = action.payload;
        },
    },
});

export const actions = slice.actions;
export const chatWidgetReducer = slice.reducer;
